import React from 'react';
import { FaRocket, FaShieldAlt, FaCloud } from 'react-icons/fa';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1 className="hero-title">
          AI Powered Suite for <span className="highlight">Tax Professionals</span>
        </h1>
        <p className="hero-subtitle">
          Comprehensive Income Tax Software, Detailed Project Report Software, 
          and Net Worth Certificate Software. Fast, easy to use, cloud-based solution.
        </p>
        <div className="hero-features">
          <span><FaRocket /> Fast & Easy to Use</span>
          <span><FaCloud /> Cloud-Based Solution</span>
          <span><FaShieldAlt /> For CA, CMA, CS, Tax Consultants</span>
        </div>
        <button className="btn btn-hero" onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}>
          Get Started Free
        </button>
      </div>
      <div className="hero-image">
        <div className="hero-stats">
          <div className="stat-item">
            <span className="stat-number">10K+</span>
            <span className="stat-label">Users</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">98%</span>
            <span className="stat-label">Satisfaction</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">4.9</span>
            <span className="stat-label">Rating</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;